const Config = {
  Scheme: "https",
  Domain: "py7.com",
  //Domain: "localhost:6443",
  PageSize: 128,
};
export default Config;
